import { Navigate, useLocation } from "react-router-dom";
import { useAuth, homeFor } from "@/context/AuthContext";
import { FullScreenLoader } from "@/components/FullScreenLoader";

export const RequireRole = ({ role, children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (user.must_change_password) return <Navigate to="/change-password" replace />;
  if (user.role !== role) return <Navigate to={homeFor(user)} replace />;
  return children;
};
